/* TCGRealm Halloween overlay (draft theme only, Oct 2026).
   - a spider on a silk thread trails the cursor (spring-damped; climbs back up when the cursor
     leaves the window); on touch it hangs and swings
   - the jack-o'-lantern docks in the header, its pupils track the cursor; click / Enter = BOO
     (a bat swarm and a toast that points to the Halloween Haul)
   - bats cross the screen every 15-35 s
   - places the per-page pieces kept in <template id="hw-tpl">: hero art + fog + cobweb, the
     Halloween Haul banner, product-page badge / cobweb / Halloween-delivery note, a candy burst
     on Add to cart, the collection-header treatment and the graveyard above the footer
   Reduced motion: nothing moves (pieces are still placed). One rAF loop, paused in background tabs. */
(() => {
  const root = document.querySelector('.hw');
  if (!root) return;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const finePointer = matchMedia('(hover: hover) and (pointer: fine)').matches;
  const spider = root.querySelector('.hw-spider');
  const thread = root.querySelector('.hw-thread');
  const pumpkin = root.querySelector('.hw-pumpkin');
  const pupils = root.querySelectorAll('.hw-pupil');
  const tpl = document.getElementById('hw-tpl');
  const piece = (sel) => tpl ? tpl.content.querySelector(sel).cloneNode(true) : null;
  const ds = root.dataset;
  const haulUrl = ds.hwHaul || '/collections/all';

  let mx = innerWidth / 2, my = innerHeight / 2, inside = false;
  addEventListener('pointermove', (e) => { mx = e.clientX; my = e.clientY; inside = true; }, { passive: true });
  document.addEventListener('mouseleave', () => { inside = false; });
  if (!finePointer) root.classList.add('is-touch');

  // ---------- pumpkin: dock in the header (floating, it covered the hero CTA) ----------
  const slot = document.querySelector('.hdr__actions');
  if (pumpkin && slot) {
    slot.prepend(pumpkin);
    pumpkin.classList.add('is-docked');
    pumpkin.setAttribute('role', 'button');
    pumpkin.setAttribute('tabindex', '0');
    pumpkin.setAttribute('aria-label', 'Boo! Happy Halloween');
    pumpkin.removeAttribute('title');
  }

  // ---------- bats ----------
  const BAT = '<svg viewBox="0 0 64 32" aria-hidden="true"><path class="hw-bat__wing hw-bat__wing--l" fill="currentColor" d="M32 14C26 6 16 4 4 8c4 2 5 5 4 8 3-2 6-1 7 2 3-3 7-2 9 1 2-3 5-3 8-1Z"/><path class="hw-bat__wing hw-bat__wing--r" fill="currentColor" d="M32 14c6-8 16-10 28-6-4 2-5 5-4 8-3-2-6-1-7 2-3-3-7-2-9 1-2-3-5-3-8-1Z"/><ellipse cx="32" cy="16" rx="3.6" ry="5" fill="currentColor"/><path fill="currentColor" d="M29.6 12l.6-3.4 1.4 2.6Zm4.8 0-.6-3.4-1.4 2.6Z"/></svg>';
  function bat(size) {
    const el = document.createElement('span');
    el.className = 'hw-bat'; el.style.setProperty('--s', size + 'px'); el.innerHTML = BAT;
    document.body.appendChild(el);
    return el;
  }
  function flyover() {
    if (document.hidden) return;
    const n = 1 + Math.floor(Math.random() * (finePointer ? 3 : 2));
    for (let k = 0; k < n; k++) setTimeout(() => {
      const el = bat(18 + Math.random() * 18);
      const ltr = Math.random() < .5, y0 = 70 + Math.random() * innerHeight * .4;
      const x0 = ltr ? -70 : innerWidth + 70, x1 = ltr ? innerWidth + 70 : -70, amp = 25 + Math.random() * 45;
      const frames = [];
      for (let i = 0; i <= 12; i++) {
        const t = i / 12;
        frames.push({ transform: `translate3d(${x0 + (x1 - x0) * t}px, ${y0 + Math.sin(t * Math.PI * 3) * amp - t * 50}px, 0) scaleX(${ltr ? 1 : -1})` });
      }
      el.animate(frames, { duration: 6500 + Math.random() * 3500, easing: 'linear' }).onfinish = () => el.remove();
    }, k * (250 + Math.random() * 400));
  }
  if (!reduce) {
    const loop = () => { flyover(); setTimeout(loop, 15000 + Math.random() * 20000); };
    setTimeout(loop, 3500 + Math.random() * 3000);
  }

  // ---------- BOO ----------
  let toast;
  function boo() {
    if (!pumpkin) return;
    pumpkin.classList.remove('is-boo'); void pumpkin.offsetWidth; pumpkin.classList.add('is-boo');
    if (!reduce) {
      const r = pumpkin.getBoundingClientRect(), cx = r.left + r.width / 2, cy = r.top + r.height / 2;
      for (let i = 0; i < 12; i++) {
        const el = bat(16 + Math.random() * 16);
        const a = Math.PI / 2 + (Math.random() - .5) * Math.PI * 1.6;      // mostly downward into the page
        const d = 180 + Math.random() * 360;
        const dx = Math.cos(a) * d, dy = Math.sin(a) * d, flip = dx < 0 ? -1 : 1;
        el.animate([
          { transform: `translate3d(${cx}px, ${cy}px, 0) scale(.2) scaleX(${flip})`, opacity: 1 },
          { transform: `translate3d(${cx + dx * .55}px, ${cy + dy * .55 - 30}px, 0) scale(1) scaleX(${flip})`, opacity: 1, offset: .55 },
          { transform: `translate3d(${cx + dx}px, ${cy + dy - 90}px, 0) scale(.85) scaleX(${flip})`, opacity: 0 }
        ], { duration: 1300 + Math.random() * 700, easing: 'cubic-bezier(.2,.7,.3,1)' }).onfinish = () => el.remove();
      }
    }
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'hw-toast'; toast.setAttribute('role', 'status');
      toast.innerHTML = `<span aria-hidden="true">👻</span><span>Boo! Happy Halloween from the vault. <a href="${haulUrl}">Open the Halloween Haul</a></span>`;
      document.body.appendChild(toast);
    }
    const hdr = document.querySelector('.hdr');                  // sit under the whole header (bar + menu), not on the menu
    toast.style.top = ((hdr ? hdr.getBoundingClientRect().bottom : 120) + 14) + 'px';
    toast.classList.add('is-on');
    clearTimeout(toast._t); toast._t = setTimeout(() => toast.classList.remove('is-on'), 4500);
  }
  if (pumpkin && pumpkin.classList.contains('is-docked')) {
    pumpkin.addEventListener('click', boo);
    pumpkin.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); boo(); } });
  }

  // ---------- per-page pieces ----------
  const web = (cls) => { const w = piece('.hw-web'); if (w) w.classList.add(...cls.split(' ')); return w; };

  const hero = document.querySelector('.hero2');
  if (hero) {
    hero.classList.add('hw-hero');
    const fog = piece('.hw-fog'); if (fog) hero.appendChild(fog);
    const w = web('hw-web--tr'); if (w) hero.appendChild(w);
  }
  document.querySelectorAll('[id$="__hw_haul"] > section').forEach((s) => {
    s.classList.add('hw-haul');
    const w = web('hw-web--tl hw-web--sm'); if (w) s.appendChild(w);
  });

  if (ds.hwTemplate === 'product') {
    const gallery = document.querySelector('.product__gallery');
    if (gallery) {
      const w = web('hw-web--tr hw-web--sm'); if (w) gallery.appendChild(w);
      if (ds.hwPick === 'true') { const b = piece('.hw-badge'); if (b) gallery.appendChild(b); }
    }
    const buy = document.querySelector('.pdp-buy');
    const cutoff = new Date('2026-10-21T04:00:00Z');                 // end of Tue 20 Oct, US Eastern
    if (buy && new Date() < cutoff) { const n = piece('.hw-note'); if (n) buy.parentNode.insertBefore(n, buy); }
  }

  if (ds.hwTemplate === 'collection') {
    const head = document.querySelector('.coll__head');
    if (head) {
      if (ds.hwColl === 'halloween-haul') head.classList.add('hw-coll-haul');
      const w = web('hw-web--tr hw-web--sm'); if (w) head.appendChild(w);
    }
  }

  const footer = document.querySelector('footer.site-footer');
  if (footer) { const y = piece('.hw-yard'); if (y) footer.parentNode.insertBefore(y, footer); }

  // ---------- candy burst on Add to cart (never blocks the click) ----------
  const CANDY = ['🍬', '🍭', '🎃', '🦇', '👻', '🕸️', '🍫'];
  document.addEventListener('click', (e) => {
    const b = e.target.closest('button[name="add"], button[data-add]');
    if (!b || b.disabled || reduce) return;
    const r = b.getBoundingClientRect(), cx = r.left + r.width / 2, cy = r.top + r.height / 2;
    for (let i = 0; i < 16; i++) {
      const el = document.createElement('span');
      el.className = 'hw-candy'; el.textContent = CANDY[i % CANDY.length];
      document.body.appendChild(el);
      const a = -Math.PI / 2 + (Math.random() - .5) * 2.2, v = 260 + Math.random() * 260, g = 900, T = 1.1 + Math.random() * .4;
      const frames = [];
      for (let k = 0; k <= 8; k++) {
        const t = (k / 8) * T;
        frames.push({ transform: `translate3d(${cx + Math.cos(a) * v * t - 11}px, ${cy + Math.sin(a) * v * t + .5 * g * t * t - 11}px, 0) rotate(${k * 40}deg)`, opacity: k > 5 ? 1 - (k - 5) / 3 : 1 });
      }
      el.animate(frames, { duration: T * 1000, easing: 'linear' }).onfinish = () => el.remove();
    }
  }, { passive: true });

  // ---------- trick-or-treat popup + floating tab ----------
  // Auto-opens ONCE per visitor (after the delay, half-way down the page, or on desktop exit intent,
  // whichever comes first), never over an open drawer/menu or while typing. Visitors who already
  // won are never auto-interrupted: the tab shows their code instead. Any link to #knock opens it.
  const pop = document.getElementById('hw-popup');
  if (pop) {
    const panel = pop.querySelector('.hwp__panel');
    const tab = document.querySelector('.hwp-tab');
    const tabText = tab && tab.querySelector('[data-hwp-tabtext]');
    const SEEN = 'tcgr-hw-popup-seen', PRIZE = 'tcgr-hw-prize-2026';
    const store = {
      get: (k) => { try { return localStorage.getItem(k); } catch (e) { return null; } },
      set: (k, v) => { try { localStorage.setItem(k, v); } catch (e) { /* private mode */ } }
    };
    const codes = [panel.dataset.hwtA, panel.dataset.hwtB, panel.dataset.hwtC].map((v) => { try { return atob(v || ''); } catch (e) { return ''; } });
    const prize = () => { try { const v = JSON.parse(store.get(PRIZE)); return v && Number.isInteger(v.t) && codes[v.t] ? v : null; } catch (e) { return null; } };
    const setTab = () => {
      const p = prize();
      if (tabText) tabText.textContent = p ? `Your code: ${codes[p.t]}` : 'Win up to 20% off';
      if (tab) tab.classList.toggle('has-prize', !!p);
    };
    setTab();
    document.addEventListener('hwt:prize', setTab);

    let lastFocus = null;
    const focusables = () => [...panel.querySelectorAll('a[href], button:not([disabled])')].filter((el) => el.offsetParent !== null);
    function openPop() {
      if (!pop.hidden) return;
      lastFocus = document.activeElement;
      pop.hidden = false;
      requestAnimationFrame(() => pop.classList.add('is-open'));
      document.documentElement.classList.add('hwp-lock');
      store.set(SEEN, '1');
      if (tab) tab.hidden = true;
      if (prize()) panel.dispatchEvent(new CustomEvent('hwt:knock'));     // straight back to their prize
      setTimeout(() => { (panel.querySelector('.hwt__btn') || focusables()[0])?.focus({ preventScroll: true }); }, 60);
    }
    function closePop() {
      if (pop.hidden) return;
      pop.classList.remove('is-open');
      document.documentElement.classList.remove('hwp-lock');
      setTimeout(() => { pop.hidden = true; if (tab) tab.hidden = false; }, reduce ? 0 : 230);
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }
    pop.addEventListener('click', (e) => { if (e.target.closest('[data-hwp-close]')) closePop(); });
    document.addEventListener('keydown', (e) => {
      if (pop.hidden) return;
      if (e.key === 'Escape') { e.preventDefault(); closePop(); return; }
      if (e.key === 'Tab') {
        const f = focusables(); if (!f.length) return;
        const i = f.indexOf(document.activeElement);
        if (e.shiftKey && i <= 0) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && (i === f.length - 1 || i === -1)) { e.preventDefault(); f[0].focus(); }
      }
    });
    document.addEventListener('click', (e) => {
      const t = e.target.closest('[data-hwp-open], a[href$="#knock"]');
      if (t) { e.preventDefault(); openPop(); }
    });

    if (!store.get(SEEN) && !prize()) {
      const delay = Math.max(3, parseFloat(pop.dataset.hwpDelay) || 8) * 1000;
      const busyUI = () => !!document.querySelector('.drawer[aria-hidden="false"], .has-mega.is-open, .facets.is-open, .hw-toast.is-on')
        || /^(INPUT|TEXTAREA|SELECT)$/.test((document.activeElement && document.activeElement.tagName) || '');
      let fired = false, timer = 0;
      const onScroll = () => { if ((scrollY + innerHeight) / document.documentElement.scrollHeight > .5) fire(); };
      const onLeave = (e) => { if (e.clientY <= 0 && !e.relatedTarget) fire(); };
      const cleanup = () => { clearTimeout(timer); removeEventListener('scroll', onScroll); document.removeEventListener('mouseout', onLeave); };
      function fire() {
        if (fired) return;
        if (busyUI()) { clearTimeout(timer); timer = setTimeout(fire, 4000); return; }
        fired = true; cleanup(); openPop();
      }
      timer = setTimeout(fire, delay);
      addEventListener('scroll', onScroll, { passive: true });
      if (finePointer) document.addEventListener('mouseout', onLeave);
    }
  }

  // ---------- spider + pumpkin eyes ----------
  let x = innerWidth * .85, y = -80, vx = 0, vy = 0, tx = x, ty = 110;
  const OX = 28, OY = -66;                          // hang above-right of the cursor, never on it
  const follow = finePointer && !reduce;
  if (finePointer && reduce) {
    spider.style.transform = `translate3d(${innerWidth - 60}px, 110px, 0)`;
    thread.style.transform = `translate3d(${innerWidth - 60}px, 0, 0)`;
    thread.style.height = '98px';
  }
  function lookAt(px, py) {
    if (!pumpkin || !pupils.length) return;
    const r = pumpkin.getBoundingClientRect();
    const cx = r.left + r.width / 2, cy = r.top + r.height * .42, a = Math.atan2(py - cy, px - cx);
    const d = Math.min(3.4, Math.hypot(px - cx, py - cy) / 70);
    const t = `translate(${(Math.cos(a) * d).toFixed(2)} ${(Math.sin(a) * d).toFixed(2)})`;
    pupils.forEach((p) => p.setAttribute('transform', t));
  }
  function tick(now) {
    if (follow) {
      if (inside) { tx = mx + OX; ty = Math.max(36, my + OY); } else { ty = -90; }
      vx = (vx + (tx - x) * .05) * .8; vy = (vy + (ty - y) * .05) * .8; x += vx; y += vy;
      const tilt = Math.max(-28, Math.min(28, vx * 2.2));
      spider.style.transform = `translate3d(${x.toFixed(1)}px, ${y.toFixed(1)}px, 0) rotate(${tilt.toFixed(1)}deg)`;
      thread.style.transform = `translate3d(${x.toFixed(1)}px, 0, 0)`;
      thread.style.height = `${Math.max(0, y - 14).toFixed(1)}px`;
      spider.classList.toggle('is-walking', Math.hypot(vx, vy) > .5);
      lookAt(mx, my);
    } else if (pumpkin) {
      const r = pumpkin.getBoundingClientRect(), s = now / 1000;
      lookAt(r.left + r.width / 2 + Math.cos(s * .9) * 200, r.top + Math.sin(s * .6) * 200);
    }
    requestAnimationFrame(tick);
  }
  if (!reduce) requestAnimationFrame(tick); else lookAt(innerWidth / 2, 0);
})();
